import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { SuggestedLocalPostData } from "../../../models/SuggestedLocalPostData";
import DataSvc from "../../../services/dataSvc";

export const useSuggestedLocalPosts = () => {
  const queryClient = useQueryClient();

  const fetchSuggestedPosts = useCallback(
    async (params: {
      locationId: string;
      offset?: number;
      limit?: number;
      order?: string;
      sort?: string;
      seek_total_count?: "true" | "false";
    }): Promise<{ data: SuggestedLocalPostData[]; count: number }> => {
      const { locationId, ...apiParams } = params;
      return await queryClient.fetchQuery(
        ["suggestedLocalPosts", locationId, apiParams],
        async () => {
          return await DataSvc.getSuggestedLocalPosts(locationId, apiParams);
        }
      );
    },
    [queryClient]
  );

  return { fetchSuggestedPosts };
};

export default useSuggestedLocalPosts;
